import React from 'react'
import { get, set } from '@cicero/data/utils'
import { IPageFilterCondition } from './helpers'

export const TextEquals: IPageFilterCondition<string> = {
  id: '$eq',
  label: 'Equals',
  addToQuery(q, filter, term) {
    // TODO If there is already a value there, add a in?
    if (filter.key && term) {
      let existingValues = get(q.selector, `${filter.key}.$in`) || get(q.selector, filter.key) || []
      if (Array.isArray(term) || q.selector[filter.key]) {
        if (!Array.isArray(existingValues)) { existingValues = [existingValues] }
        const termArray = Array.isArray(term) ? term : [term]
        set(q.selector, filter.key, { $in: existingValues.concat(termArray) })
      } else {
        set(q.selector, filter.key, term)
      }
    }
    return q
  },
}

export const TextLike: IPageFilterCondition<string> = {
  id: '$like',
  label: 'Matches',
  addToQuery(q, filter, term) {
    if (filter.key && term) {
      set(q.selector, filter.key, { $regex: new RegExp(`.*${term}.*`, 'i') })
    }
    return q
  },
}

export const HasValue: IPageFilterCondition<boolean> = {
  id: '$exists',
  label: 'Exists',
  addToQuery(q, filter) {
    if (filter.key) { set(q.selector, filter.key, { $exists: true }) }
    return q
  },
  validateTerm() { return true },
  renderForm() { return <></> },
}

export const HasNoValue: IPageFilterCondition<boolean> = {
  id: '$not-exists',
  label: 'Is Empty',
  addToQuery(q, filter) {
    if (filter.key) { set(q.selector, filter.key, { $exists: false }) }
    return q
  },
  validateTerm() { return true },
  renderForm() { return <></> },
}

export const DEFAULT_CONDITIONS: IPageFilterCondition<any>[] = [
  TextEquals,
]
